const auth = {
  isConcordeAdmin: (state) => {
    const { auth: { user } } = state
    return user && !!user.isConcordeAdmin
  }
}

export { auth }